// @ts-nocheck

/**
 * Reset KL eligible collectible ids
 * @param  {Object} state        The actual state.
 * @return {Object}              Return the new state.
 */
const resetKLEligibleCollectibles = (state) => {
  const { items } = state;

  let newState = null;

  if (!state.eligibleKLCollectibleId) {
    newState = { ...state, eligibleKLCollectibleId: null };
  }

  const changedItems = {};
  Object.keys(items).forEach((key) => {
    if (items[key].eligibleKLCollectibleId) {
      changedItems[key] = { ...items[key], eligibleKLCollectibleId: null };
    }
  });

  if (Object.keys(changedItems).length) {
    if (newState) {
      newState.items = { ...newState.items, ...changedItems };
    } else {
      newState = { ...state, items: { ...items, ...changedItems } };
    }
  }

  return newState ?? state;
};

export default resetKLEligibleCollectibles;
